import type { JobSalary } from "@lossdog/job-watchlists";
import { useMemo } from "react";

import { useJobSalaryContext } from "@/data/watchlist/JobSalary.context";
import { logger } from "@/util/logger";

interface UseRelatedJobSalariesReturn {
  relatedJobSalaries: JobSalary[];
  isLoading: boolean;
}

export const useRelatedJobSalaries = (jobData: JobSalary | null): UseRelatedJobSalariesReturn => {
  const { jobSalaryClient, isLoading: contextLoading } = useJobSalaryContext();

  const relatedJobSalaries = useMemo(() => {
    if (!jobSalaryClient || !jobData || contextLoading) {
      return [];
    }

    try {
      return jobSalaryClient.getRelatedJobSalaries(jobData);
    } catch (error) {
      logger.error("Failed to get related job salaries:", error);
      return [];
    }
  }, [jobSalaryClient, jobData, contextLoading]);

  return {
    relatedJobSalaries,
    isLoading: contextLoading,
  };
};
